export type skillType = { value: string; label: string };

const Skills: skillType[] = [
  { value: "Android", label: "Android" },
  { value: "Bash", label: "Bash" },
  { value: "C ", label: "C" },
  { value: "C#", label: "C#" },
  { value: "C++", label: "C++" },
  { value: "Go", label: "Go" },
  { value: "Hardware", label: "Hardware" },
  { value: "HTML/CSS", label: "HTML/CSS" },
  { value: "iOS", label: "iOS" },
  { value: "Java", label: "Java" },
  { value: "JavaScript", label: "JavaScript" },
  { value: "Kotlin", label: "Kotlin" },
  { value: "Machine Learning", label: "Machine Learning" },
  { value: "Node", label: "Node" },
  { value: "Perl", label: "Perl" },
  { value: "PHP", label: "PHP" },
  { value: "Python", label: "Python" },
  { value: "R ", label: "R" },
  { value: "React", label: "React" },
  { value: "Robotics", label: "Robotics" },
  { value: "Ruby", label: "Ruby" },
  { value: "Rust", label: "Rust" },
  { value: "Scala", label: "Scala" },
  { value: "SQL", label: "SQL" },
  { value: "Swift", label: "Swift" },
  { value: "TypeScript", label: "TypeScript" },
  { value: "UI/UX Design", label: "UI/UX Design" },
];

export default Skills;
